import React, {useState} from 'react';
import DeathSaves from '../../../../playerView/components/DeathSaves.js';
import HpHistRow from './HpHistRow.js';

const HpEditPopup = ({creature, setCreature, currentEncounter, hpHist, setHpHist, handleCreatureChange, setMaxHp, setCurrentHp, socket}) => {
    // Track previous index for animation direction

    const [hpChange, setHpChange] = useState(0);
    const [openHist, setOpenHist] = useState(false);
    const [hpHistItem, setHpHistItem] = useState(
        {
            before: creature.hit_points_current,
            beforeTemp: creature.hit_points_current,
            input: 0,
            inputType: "normal",
            after: 0,
            afterTemp: 0,
            rt: currentEncounter.roundNum + "." + currentEncounter.turnNum,
            onTurnName: currentEncounter?.creatures[currentEncounter.turnNum-1]?.name
        }
    );

    const handleChangeHpCreature = (type, event) => {
        event.stopPropagation()

        hpHistItem.before = creature.hit_points_current;
        hpHistItem.beforeTemp = creature.hit_points_temp;
        hpHistItem.input = hpChange;
        hpHistItem.inputType = "normal";


        let hpNum = hpChange;
        if(type === 'damage') {
            if(creature.hit_points_temp > 0) {
                 
                let tempHpRemainder = creature.hit_points_temp - hpChange
                if(tempHpRemainder <= 0) {
                    hpNum = Math.abs(tempHpRemainder)
                    creature.hit_points_temp = 0
                } else {
                    hpNum = 0
                    creature.hit_points_temp = tempHpRemainder
                }

            }

            hpNum *= -1     
            hpHistItem.input = hpChange * -1; 
        }
        creature.hit_points_current = parseInt(creature.hit_points_current) + hpNum

        if(creature.hit_points_current > creature.hit_points)
            creature.hit_points_current = creature.hit_points

        hpHistItem.after = creature.hit_points_current
        hpHistItem.afterTemp = creature.hit_points_temp; 
        // hpHistItem.rt = currentEncounter.roundNum + "." + currentEncounter.turnNum; 


        //hit_points | hit_points_current | hit_points_temp | hit_points_override
        socket.emit('playerHpChange', {hit_points_current: creature.hit_points_current, hit_points_temp: creature.hit_points_temp}, creature.creatureGuid, "dm");
        setHpHistItem({...hpHistItem})
        setHpHist(prev => [{...hpHistItem}, ...prev])
        setCurrentHp(creature.hit_points_current)
        setCreature({...creature})
        handleCreatureChange()
    }

    const handleOverrideHp = (event) => {
        if(!isNaN(event.target.value)) {
            let override = parseInt(event.target.value) || 0


            hpHistItem.before = creature.hit_points_current;
            hpHistItem.beforeTemp = creature.hit_points_temp;
            hpHistItem.input = override;
            hpHistItem.inputType = "override";
            setHpHistItem({...hpHistItem})
        
            // Set override in creature
            creature.hit_points_override = override
            
            setCreature({...creature})
            handleCreatureChange()
        }
    }

    const submitOverRideHpChange = () => {
        if(creature.hit_points_override !== creature.hit_points) {

            // Find old diff between current and max
            let dif = creature.hit_points - creature.hit_points_current
            creature.hit_points = creature.hit_points_override === 0 ? creature.hit_points_default : creature.hit_points_override
            creature.hit_points_current = creature.hit_points - dif

            hpHistItem.after = creature.hit_points_current;
            hpHistItem.afterTemp = creature.hit_points_temp;
            setHpHistItem({...hpHistItem})
            setHpHist(prev => [{...hpHistItem}, ...prev])

            setCurrentHp(creature.hit_points_current)
            setMaxHp(creature.hit_points)
            
            //hit_points | hit_points_current | hit_points_temp | hit_points_override
            socket.emit('playerHpChange', {
                hit_points: creature.hit_points,
                hit_points_current: creature.hit_points_current,
                hit_points_override: creature.hit_points_override,
            }, creature.creatureGuid, "dm");
            setCreature({...creature})

            handleCreatureChange()
        }
    }

    const handleTempHp = (event) => {

        if(!isNaN(event.target.value)) {
            let tempHp = parseInt(event.target.value)
            hpHistItem.before = creature.hit_points_current;
            hpHistItem.beforeTemp = creature.hit_points_temp;
            hpHistItem.input = tempHp;
            hpHistItem.inputType = "temp";
            setHpHistItem({...hpHistItem})

            creature.temptemp = isNaN(tempHp) ? 0 : tempHp
            setCreature({...creature})
            handleCreatureChange()
        }
    }

    const submitTempHpChange = () => {
        // if temptemp is undefined then the user didnt enter new data
        if(creature.temptemp && creature.temptemp !== creature.hit_points_temp) {
            hpHistItem.after = creature.hit_points_current
            hpHistItem.afterTemp = creature.temptemp
            setHpHist(prev => [{...hpHistItem}, ...prev])

            creature.hit_points_temp = creature.temptemp
            creature.temptemp = undefined
            
            //hit_points | hit_points_current | hit_points_temp | hit_points_override
            socket.emit('playerHpChange', {hit_points_temp: creature.hit_points_temp}, creature.creatureGuid, "dm");
            setCreature({...creature})
            handleCreatureChange()
        }
    }

    const handleHpChange = (event) => {
        if(!isNaN(event.target.value)) { 
            let input = event.target.value; 
            setHpChange(input === '' ? '' :  parseInt(event.target.value)) 
        }
    }

    const handleHighlight = (e) => {
        e.target.select();
    };

    let tempHp = creature.temptemp || creature.hit_points_temp

    let maxHeight = creature.hit_points_current < 1 && creature.type === 'player' ? '270px' : '190px'
    return (
        <div className='hpPopupContainer'>
            {openHist && 
                <div className='hpHistoryContainer' style={{maxHeight: maxHeight}}>
                    <div className='hpHistGrid hpHistGridTop' style={{backgroundColor: "#bebebe", height: '10%', overflowY: "hidden", gridTemplateRows: '100%'}}>
                        <div className='histItem'>R.T</div>
                        <div/>
                        <div className='histItem'>Old</div>
                        <div className='histItem'>+/-</div>
                        <div className='histItem'>Input</div>
                        <div className='histItem'>⇒</div>
                        <div className='histItem'>New</div>
                    </div>
                    <div className='hpHistGrid'>
                        {hpHist.map((hpItem, idx) => {
                            return <HpHistRow key={idx} hpItem={hpItem} idx={idx}/>
                        })}
                    </div>
                </div>
            }
            <div className='hpLogButton' onClick={() => {setOpenHist(!openHist)}} title='Hp History'>
                <svg width="14" height="14" viewBox="0 0 14 14"
                    style={{
                        display: "block",
                        transform: openHist ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.15s"
                    }}
                >
                    <polyline points="4,3 9,7 4,11" fill="none" stroke="#822000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div><b>H</b></div>
                <div><b>P</b></div>
                <div><b>-</b></div>
                <div><b>L</b></div>
                <div><b>O</b></div>
                <div><b>G</b></div>
                <svg width="14" height="14" viewBox="0 0 14 14"
                    style={{
                        display: "block",
                        transform: openHist ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.15s"
                    }}
                >
                    <polyline points="4,3 9,7 4,11" fill="none" stroke="#822000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>

            </div>
            <div className='hpEditContainer'>
                <div className="hpContainerFlag" style={{bottom: creature.hit_points_current <= 0 ? "10%" : "15%"}}/>
                <div>
                    <div className='extraHpInputs' >
                        <label className='hpTitle tempHp' style={{color: tempHp === 0 ? 'grey' : ''}} htmlFor='temphp'><strong>Temp HP</strong></label>
                        <input id='temphp' type='number' className='editStatsInputExtra tempHp' value={tempHp} style={{color: tempHp === 0 ? 'grey' : ''}} onFocus={handleHighlight} onChange={handleTempHp} onBlur={submitTempHpChange}/>
                    </div>
                    <div className='extraHpInputs'>
                        <label className='hpTitle' htmlFor='override' style={{color: creature.hit_points_override === 0 ? 'grey' : ''}}><strong>Override HP</strong></label>
                        <input id='override' type='number' className='editStatsInputExtra' value={creature.hit_points_override} style={{color: creature.hit_points_override === 0 ? 'grey' : ''}} onFocus={handleHighlight} onChange={handleOverrideHp} onBlur={submitOverRideHpChange}/>
                    </div>
                </div>
                <hr className='hplineSeperator'/>
                <div className='editHpContainer'>
                    <button className='editHpButton healButton' onClick={(event) => handleChangeHpCreature("heal", event)}>HEAL</button>
                    <input className='editStatsInput' value={hpChange} onChange={handleHpChange} autoFocus onFocus={handleHighlight}/>
                    <button className='editHpButton damageButton' onClick={(event) => handleChangeHpCreature("damage", event)}>DAMAGE</button>
                </div>
                <hr className='hplineSeperator'/>
                {creature.type === "player" && creature.hit_points_current <= 0 && 
                    <div>
                        <div style={{color: "#822000"}}><strong>Death Saves</strong></div>
                        <div style={{background: "#ddd3a3ff", border: "2px solid grey", borderRadius: "5px", padding: "2px 2px 2px 0px", margin: "0px 6px 4px 0px"}}>
                            <DeathSaves creatueGuid={creature.creatureGuid} pass={creature.death_saves_success_count} fail={creature.death_saves_failure_count} socket={socket}/>
                        </div>
                    </div>
                }
            </div>
            
        </div>
    );
}

export default HpEditPopup;